import { userErrorFragment, checkoutUserErrorFragment } from './fragmentGeneral.gql';
import checkoutFragment from './fragmentCheckout.gql';

const checkoutLineItemsReplace = ({ country }) => (
	`mutation ($checkoutId: ID!, $lineItems: [CheckoutLineItemInput!]!) @inContext(country: ${country}) {
		checkoutLineItemsReplace(checkoutId: $checkoutId, lineItems: $lineItems) {
			userErrors ${userErrorFragment}
			checkoutUserErrors ${checkoutUserErrorFragment}
			checkout ${checkoutFragment}
		}
	}`
);

export default checkoutLineItemsReplace;
